import React from "react";
import Header from "../../components/header";
import Footer from "../../components/footer";

import RecordReqList from './recordReqInfoList';
import FacilityEmrList from './facilityDetails';

class EmployeHome extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
 
      RecordReqLista: true,
      FacilityEmrLista:false,
      index:1
    };
  }
  settingsNav = (e) => {
    e.preventDefault();
      this.setState({
        index : e.target.id
      })
    
  }

  render() {
    const {  index,   } = this.state
    return (

      <React.Fragment>
        <Header routes={[{ "name": "Home", "route": "/EmployeHome", }]} status={"afterLogin"} />

        <div className="content">

          <div className="contentSection" id="content">
            <div className="container-fluid">

              <div className="bodyContent">
                <div className=" set-page row">
                  <div className="set-but">
                    <div className="col-lg-3 col-md-3">
                      <ul class="set-ul" type="none">

                        <li  onClick={this.settingsNav} id={1} className={index == 1 ? "active" : ""}  >
                           Requested Records 
                        </li>
                        <li  onClick={this.settingsNav} id={2} className={index == 2 ? "active" : ""}  >
                           Awaiting for Payment 
                        </li>

                        <li  onClick={this.settingsNav} id={3} className={index == 3 ? "active" : ""}  >
                           Completed Records 
                        </li>

                        <li  onClick={this.settingsNav} id={4} className={index == 4 ? "active" : ""}  >
                           Practice Details 
                        </li>

                       

                      </ul>
                    </div></div>
                  <div className="col-lg-9 col-md-9">
    
                    {index == 1 &&
                      <RecordReqList tab={"Requested"} />
                    }

                     {index == 2 &&
                      <RecordReqList tab={"Pending"} />
                    }

                      {index == 3 &&
                      <RecordReqList tab={"Completed"} />
                    }

                    {index == 4 &&
                      <FacilityEmrList />
                    }

                 


                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
        {/* <!-- Edit data --> */}

      </React.Fragment>

    )
  }
}

export default EmployeHome;






